export const selectOrder = (reduxState) => reduxState.order;
